<template>
    <ai-grid-edit
        ref="userRefBooksRef"
        :meta="meta"
        :args="args"
        :hasnt-route="true"
        :to-remove-toolbar-items-names="['choice', 'copy', 'edit', 'add', 'delete']"
    />
</template>
<script setup>
import {onMounted, computed, ref} from 'vue';
import {getGlobYm} from "@/layouts/main-layout/main-layout-data";

const props = defineProps({
    api: {type: Object, required: true},
    dropDownApi: {type: Object, required: true},
    objname: {type: String, required: true},
    objid: {type: Number, required: true},
});
const userRefBooksRef = ref();
const globYm = ref();
const getDropDownComponent = (kod_refbook) => {
    const getDropDownSelectArgs = (kod_refbook) => {
        return {
            meta_args: {select: 'nsi.kf_refcode_get'},
            select_args: kod_refbook ? {kod_refbook} : {},
        };
    };

    return {
        path: 'components/ai-grid-ro/ai-grid-ro.vue',
        text: 'name',
        meta: {
            keyExpr: 'kod_refcode',
            columns: [
                {dataField: 'kod_refbook', caption: 'kod_refbook', visible: false},
                {dataField: 'kod_refcode', caption: 'kod_refcode', visible: false},
                {dataField: 'num', caption: 'Номер'},
                {dataField: 'name', caption: 'Значение'}
            ],
            api: props.dropDownApi,
        },
        args: getDropDownSelectArgs(kod_refbook)
    };
}
const meta = {
    keyExpr: 'kod_refbook',
    viewId: 'userRefBooksView',
    selectionMode: 'single',
    columns: [
        {
            dataField: 'objid',
            visible: false,
            dataType: 'number',
            allowEditing: false,
        },
        {
            dataField: 'kod_refbook',
            visible: false,
            dataType: 'number',
            allowEditing: false,
        },
        {
            dataField: 'kod_refprop',
            visible: false,
            dataType: 'number',
            allowEditing: false,
        },
        {
            dataField: 'refcode_name',
            visible: false,
            allowEditing: false,
        },
        {
            dataField: 'refbook_name',
            caption: 'Наимен. атрибута',
            fixed: true,
            allowEditing: false,
        },
        {
            dataField: 'kod_refcode',
            caption: 'Значение',
            dataType: 'number',
            editor: {type: 'ai-drop-down', text: 'refcode_name'},
            component: getDropDownComponent()
        }
    ],
    api: props.api,
};
const args = computed(() => {
    return {
        select: {
            meta_args: {select: 'nsi.kf_refbook_get'},
            select_args: {objname: props.objname, objid: props.objid}
        },
        save: {
            meta_args: {update: 'nsi.kf_refprop_save'},
            update_args: {save_history: true, ym: globYm.value},
        }
    }
});

const onFocusedRowChanged = (e) => {
    if (e.row.key) {
        userRefBooksRef.value?.gridInstance.columnOption('kod_refcode', {componentMeta: getDropDownComponent(e.row.key)});
    }
};

onMounted(async () => {
    globYm.value = await getGlobYm();
    userRefBooksRef.value.gridInstance.on('focusedRowChanged', onFocusedRowChanged);
});
</script>